module.exports = {
  '56940': {
    name: 'A',
    id: '5e3548c6d32cb12606a34fba'
  },
  '56983': {
    name: 'Chou',
    id: '5ee750bfaf5cfe001a6f40da'
  },
  '56981': {
    name: 'Mustard sneakers',
    id: '5ee75026af5cfe001a6f40cf'
  },
  '56982': {
    name: 'Tallulah',
    id: '5ee74ff0af5cfe001a6f40c0'
  },
  '56984': {
    name: 'A pale petal',
    id: '5ef2db51b74c35001afef205'
  }
}



// WEBPACK FOOTER //
// ./src/config/new-member-store.js